import { Component, Input, OnInit } from '@angular/core';
import { TemplateService } from '../../services/template.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-tpl-name',
  template: `
    <nz-form-item>
      <nz-form-label [nzSpan]="3" nzRequired>模板名称</nz-form-label>
      <nz-form-control [nzSpan]="10" [nzErrorTip]="nameTips">
        <input
          [name]="'name' + index"
          nz-input
          [(ngModel)]="item.name"
          placeholder="模板名称长度1~30字符"
          maxlength="30"
          required
          (ngModelChange)="nameChange($event, index)"
        />
        <ng-template #nameTips let-control>
          <ng-container *ngIf="control.hasError('required')">
            模板名称不能为空
          </ng-container>
        </ng-template>
        <span style="color: red;" *ngIf="!item.valid">
          模板名称不能重复
        </span>
      </nz-form-control>
    </nz-form-item>
  `,
})
export class IccTplNameComponent implements OnInit {
  /** 消息类型 */
  @Input() type: any;
  /** 当前模板的索引 */
  @Input() index: number;

  /** 当前消息类型的资源 */
  source: any;
  /** 当前消息类型下的模板 */
  item: any;

  constructor(private templateService: TemplateService) {}

  ngOnInit() {
    this.source = this.templateService.getMsg(this.type) || [];
    this.item = this.templateService.getTpl(this.type)[this.index] || [];
  }

  nameChange(name: string, index: number): void {
    this.templateService.validateName(name, index, this.type);
  }
}
